import { render, staticRenderFns } from "./chanpinjiaohu.vue?vue&type=template&id=7b29a4b0"
import script from "./chanpinjiaohu.vue?vue&type=script&lang=js"
export * from "./chanpinjiaohu.vue?vue&type=script&lang=js"
import style0 from "./chanpinjiaohu.vue?vue&type=style&index=0&id=7b29a4b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports